/**
 * 处理tab窗口缩放事件
 */
import _ from 'lodash';

export default {
    data() {
        return {
            pageContent: {
                height: "500px"
            }
        }
    },
    computed: {
        $computTabHeight() {
            return this.getAutoHeightHandle();
        },
        $tabResize() {
           return  _.debounce(() => {
                if (this.pageContent) {
                    this.pageContent.height = this.getAutoHeightHandle() + "px";
                } else {
                     console.log("pageContent 不存在");
                }
            }, 400)
        }
    },
    mounted() {
        if (process.env.NODE_ENV== 'development') {
            console.log("-- addEventListener  resize ---");
        }
        this.$nextTick(()=>{
            this.pageContent.height = this.$computTabHeight + "px";
        })
        window.addEventListener('resize', this.$tabResize)
    },
    deactivated() {
        if (process.env.NODE_ENV== 'development') {
            console.log("-- removeEventListener  resize ---");
        }
        window.removeEventListener('resize', this.$tabResize)
    },
   methods: {
        getAutoHeightHandle() {
            let defTabHeight = 600;
            let defSearchHeight = 0;
            let defTagsHeight = 0;
            let defOperButtonHeight = 0;
            let defCrumbsHeight = 0;
            let defPaddingHeight = this.$constant.DEF_PADDING_HEIGHT;
            let defPageHeight = 0;
            if (this.$refs.commonSearchRef) {
                if (process.env.NODE_ENV== 'development') {
                    console.log(" commonSearchRef 存在" );
                }
                defSearchHeight = this.$refs.commonSearchRef.clientHeight;
                defPaddingHeight = 5;
            } else {
                if (process.env.NODE_ENV== 'development') {
                    console.log(" commonSearchRef 不存在" );
                }
                defPaddingHeight = 10;
            }
            if (this.$refs.commonOperBtnRef) {
                defOperButtonHeight = this.$refs.commonOperBtnRef.clientHeight;
            } 
            if (this.$refs.commonCrumbsRef) {
                defCrumbsHeight = this.$refs.commonCrumbsRef.clientHeight;
            } 

            if (this.$refs.commonPageRef) {
                defPageHeight = this.$refs.commonPageRef.clientHeight;
            } 

            try {
                if (this.$parent.$refs.myHomeTagsRef && this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef) {
                    defTagsHeight = this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef.clientHeight;
                }
            } catch (error) {
                console.log(" compute Tags height faild!!! "+error);
            }
            defTabHeight = window.innerHeight - this.$constant.DEF_HEADER_HEIGHT - defSearchHeight - defOperButtonHeight - defTagsHeight - defCrumbsHeight - defPaddingHeight - defPageHeight;
            return defTabHeight;
        }
   }

}